export default "__VITE_ASSET__4f7b1fca__"